import React, { useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import {
  Button,
  Box,
  Alert,
  CircularProgress,
  TextField,
} from "@mui/material";

import { forgetPassword as adminForgetPassword } from "../../apis/admin";
import { forgetPassword as dealerForgetPassword } from "../../apis/dealer";
import { AuthLayout } from "../../components/AuthLayout";

export const ForgotPasswordPage: React.FC = () => {
  const [emailError, setEmailError] = useState(true);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!/^[a-zA-Z0-9._:$!%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(e.target.value)) {
      setEmailError(true);
    } else {
      setEmailError(false);
      setError("");
    }
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsLoading(true);
    setSuccess("");
    setError("");

    if (emailError) {
      setError("Please enter a valid email address.");
      setIsLoading(false);
      return;
    }

    const formData = new FormData(e.currentTarget);
    const formValues: any = Object.fromEntries(formData.entries());

    for (const key in formValues) {
      if (formValues[key] === "") {
        delete formValues[key];
      }
    }

    // Try admin forgot password first, then dealer
    try {
      const res = await adminForgetPassword(formValues);
      if (res?.success) {
        setSuccess("Check your email for a password reset link.");
        setIsLoading(false);
        return;
      }
    } catch {}

    try {
      const res = await dealerForgetPassword(formValues);
      if (res?.success) {
        setSuccess("Check your email for a password reset link.");
        setIsLoading(false);
        return;
      }
    } catch {}

    setError("No account found with that email address.");
    setIsLoading(false);
  };

  return (
    <AuthLayout title="Forgot Password" subtitle="Enter your email to reset your password">
      <form onSubmit={handleSubmit}>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}
        {success && (
          <Alert severity="success" sx={{ mb: 2 }}>
            {success}
          </Alert>
        )}
        <TextField
          id="email"
          label="Email Address"
          name="email"
          required
          fullWidth
          autoComplete="email"
          onChange={handleEmailChange}
        />
        <Button
          type="submit"
          fullWidth
          variant="contained"
          color="secondary"
          disabled={isLoading}
          sx={{
            mt: 2.5,
            py: 1.3,
            fontSize: "0.938rem",
            fontWeight: 600,
          }}
        >
          {isLoading ? <CircularProgress size={24} color="inherit" /> : "Send Reset Link"}
        </Button>
        <Box sx={{ mt: 2, textAlign: "center" }}>
          <RouterLink
            to="/login"
            style={{ color: "#64748B", fontSize: "0.875rem", textDecoration: "none" }}
          >
            Back to Sign In
          </RouterLink>
        </Box>
      </form>
    </AuthLayout>
  );
};
